import React, { PureComponent } from 'react';
import { t } from 'ttag';

export default class ConfirmStep extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      common: window.campaign_data.common_translations.blocks,
      text: '',
      text2: '',
      text3: '',
    };
  }

  componentDidMount() {
    this.setState({
      text: t`You’re at the goal line!`,
      text2: t`If you are new at Unisport you need to confirm that you’re not a robot by clicking the confirmation mail we just sent you.`,
      text3: t`Not receiving emails from us? Please check your spam folder.`,
    });
  }

  render() {
    return (
      <section className="confirm-section">
        <div className="confirmationTextHolder">
          <div className="confirmation1">
            <h4
              className="confirmationTitle"
              style={{ color: this.props.titleColor }}
            >
              {this.state.common.successheadline}
            </h4>
            <p style={{ color: this.props.textColor }}>{this.state.text}</p>
            <p style={{ color: this.props.textColor }}>{this.state.text2}</p>
            <p style={{ color: this.props.textColor }}>{this.state.text3}</p>
          </div>
        </div>
      </section>
    );
  }
}
